<template>
  <div class="charts-wrap" v-if="loading">
    <v-row class="charts-title">
      <v-col>
        <div class="charts-title-text">Participation trend overtime</div>
      </v-col>
    </v-row>
    <v-row v-if="chartData.length > 0">
      <v-col cols="3" v-for="(item, index) in chartData" :key="index" style="position:relative;">
        <div v-if="isChartLoading(index)" :class="`isLoading${item.title}`" style="position:absolute;left:40%;top:30%;z-index:99;">
          <v-btn :loading="true" text x-large fab></v-btn>
          <div class="pl-1">Loading...</div>
        </div>
        <div class="chartdiv" :id="item.title">
        </div>
        <div class="chart-heading">{{item.title}}</div>
      </v-col>
    </v-row>
    <v-row v-if="chartData.length === 0">
      <p class="w-100 text-center pt-4 mt-4 pb-4 mb-4">Not enough data to generate analysis.</p>
    </v-row>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs-ext/plugin/customParseFormat';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
am4core.useTheme(am4themes_animated);

export default {
  name: 'RateTrend',

  props: {
    trendData: {
      required: false,
      type: Object
    }
  },

  data () {
    return {
      chartData: [],
      loading: true,
      isLoading0: true,
      isLoading1: true,
      isLoading2: true,
      isLoading3: true,
      isLoading4: true,
      isLoading5: true,
      isLoading6: true,
      isLoading7: true,
      isLoading8: true,
      isLoading9: true
    };
  },

  watch: {
    trendData: {
      // immediate: true,
      deep: true,
      handler () {
        this.resetChartLoaders();
        this.updateChart();
      }
    }
  },

  beforeDestroy () {
    am4core.disposeAllCharts();
    this.loading = false;
  },

  methods: {
    resetChartLoaders () {
      this.isLoading0 = true;
      this.isLoading1 = true;
      this.isLoading2 = true;
      this.isLoading3 = true;
      this.isLoading4 = true;
      this.isLoading5 = true;
      this.isLoading6 = true;
      this.isLoading7 = true;
      this.isLoading8 = true;
      this.isLoading9 = true;
    },
    isChartLoading (idx) {
      return this[`isLoading${idx}`];
    },
    createChartData () {
      this.chartData = [];
      this.$lodash.each(this.trendData, (val, key) => {
        const dataPoints = [];
        this.$lodash.each(val, (v) => {
          const t = {};
          t.value = v.participation_rate;
          t.date = v.key;
          dataPoints.push(t);
        });
        const temp = {};
        temp.data = dataPoints;
        temp.title = key;
        this.chartData.push(temp);
      });
    },
    updateChart () {
      this.chartData = [];
      this.$lodash.each(this.trendData, (val, key) => {
        const dataPoints = [];
        this.$lodash.each(val, (v) => {
          const t = {};
          t.value = v.participation_rate;
          const td = new Date(v.key);
          t.date = dayjs(td).format('MMM \'YY');
          dataPoints.push(t);
        });
        const temp = {};
        temp.data = dataPoints;
        temp.title = key;
        this.chartData.push(temp);
      });
      setTimeout(() => {
        this.chart();
      }, 25);
    },
    chart () {
      this.$lodash.each(this.chartData, (val, index) => {
        this.createMultiTrend(val.data, val.title, index);
      });
    },
    createMultiTrend (data, type, index) {
      var testChart = am4core.create(type, am4charts.XYChart);
      testChart.data = data;
      testChart.preloader.disabled = true;
      const that = this;
      testChart.events.on('ready', function (ev) {
        const temp = `isLoading${index}`;
        that[temp] = false;
      });
      var categoryAxis = testChart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'date';
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.line.strokeOpacity = 1;
      categoryAxis.renderer.line.strokeWidth = 1.5;
      categoryAxis.renderer.grid.template.location = 0;
      var valueAxis = testChart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 1.5;
      valueAxis.baseValue = 0;
      valueAxis.min = 0;
      valueAxis.max = 110;
      valueAxis.strictMinMax = true;
      // valueAxis.title.text = type;
      var series1 = testChart.series.push(new am4charts.LineSeries());
      series1.dataFields.valueY = 'value';
      series1.dataFields.categoryX = 'date';
      series1.name = 'Chat Responses';
      series1.strokeWidth = 3;
      series1.fill = '#050550';
      series1.stroke = am4core.color('#050550');
      series1.tensionX = 0.6;
      series1.fillOpacity = 0;
      series1.tooltipHTML = `<center><strong>Month {categoryX}</strong></center>
      <hr />
      <table>
      <tr>
        <th align="left"></th>
        <td>{valueY}</td>
      </tr>
      </table>`;
      testChart.cursor = new am4charts.XYCursor();
      // eslint-disable-next-line no-unused-vars
      var bullet1 = series1.bullets.push(new am4charts.CircleBullet());
    }
  }
};
</script>

<style lang="scss" scoped>
.charts-wrap {
  .charts-title {
    margin: 0;
    .charts-title-text {
      font-size: var(--heading-size);
      color: var(--color-text);
    }
  }
}
.chartdiv {
  height: 250px !important;
}
.chart-heading {
  text-align: center;
  font-weight: 500;
  font-size: var(--content-size);
  color: var(--color-text);
  width: 99.9%;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
